<template>
  <h1 class="font-jost-regular !text-blue-dark !text-[25px] !leading-[36px]">
    {{ title }}
  </h1>
</template>

<script>
export default {
  name: 'TxTitleComponent',
  props: {
    txType: {
      type: String,
      required: true,
    },
  },
  computed: {
    title() {
      switch (this.txType) {
        case 'coin':
          return 'Coin Asset Transaction';
        case 'transfer':
          return 'Transfer Transaction';
        case 'proxyCreate':
          return 'Create Proxy Transaction';
        case 'stack':
          return 'Stack Transaction';
        case 'attestCommit':
          return 'Receipt ID';
        case 'nftMint':
          return 'Digital Asset';
        case 'nft':
          return 'Digital Asset Transfer Transaction';
        default:
          return '';
      }
    },
  },
}
</script>

<style scoped>
h1 {
  font-family: 'Jost', sans-serif;
  color: #2A4067;
  font-size: 25px;
  line-height: 36px;
  margin-bottom: 20px;
}
</style>
